module.exports = __webpack_public_path__ + "img/12.85ec0974.jpg";